import { useState, useEffect } from 'react';
import client from 'utils/client';

function useSettings() {
    const [loading, setLoading] = useState(false);
    const [settingsData, setSettingsData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        setLoading(true);
        client
            .get('/settings')
            .then((response) => {
                setSettingsData(response.data.data);
            })
            .catch((error) => {
                setError(error);
            })
            .finally(() => setLoading(false));
    }, []);

    const getFeeConfig = (providerId) => {
        if (!settingsData || !settingsData.length) return null;
        if (providerId) {
            return settingsData.find(item => item.type === 'FEE_CONFIG' && Number(item.terminal_provider_id) === Number(providerId));
        }
        return settingsData.find(item => item.type === 'FEE_CONFIG');
    };

    return {
        loading,
        error,
        settingsData,
        getFeeConfig,
    };
}

export default useSettings;